import React, { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Checkbox, Form, Input, Layout, message, Modal } from "antd";
import Register from "./Register";
import NetworkApi from "../../network/networkApi";
import {
  UserOutlined,
  LockOutlined,
  FileDoneOutlined,
  QrcodeOutlined,
  FilePdfFilled,
  TwitterOutlined,
  FacebookFilled,
  SafetyOutlined,
  SearchOutlined,
  LinkOutlined,
  PhoneOutlined,
  BankOutlined,
} from "@ant-design/icons";
import { USER_ROLE } from "../../enums/user.enum";
import "./login.css";
import License from "../lib/License";

/* ── Data ── */

const rulesData = [
  {
    number: "1",
    name: "Монгол Улсад 2026 онд хөдөө аж ахуйд ургамал хамгааллын зориулалтаар ашиглаж болох пестицид, Газар тариалангийн зориулалтаар ашиглаж болох химийн бордооны жагсаалт батлах тухай Байгаль орчин, уур амьсгалын өөрчлөлтийн сайд, Хүнс, хөдөө аж ахуй, хөнгөн үйлдвэрийн сайд, Эрүүл мэндийн сайдын хамтарсан тушаал.",
    date: "2026.02.24",
    link: "https://mofa.gov.mn/files/pdf-files/rca7qj1d3q/69b2836b299cc549f5ef4d61.pdf",
  },
  {
    number: "2",
    name: "Ургамал, түүний гаралтай хүнсний түүхий эд, бүтээгдэхүүний ул мөрийг мөрдөн тогтоох бүртгэлийн журам",
    date: "2022-06-27",
    link: "https://legalinfo.mn/mn/detail?lawId=16530810646881&showType=1",
  },
  {
    number: "3",
    name: "Тариалангийн үйлдвэрлэл эрхэлж байгаа иргэн, хуулийн этгээдийн үйлдвэрлэсэн бүтээгдэхүүнд мөнгөн урамшуулал олгох, мөнгөн бус дэмжлэг үзүүлэх журам",
    date: "2022-07-06",
    link: "https://legalinfo.mn/mn/detail?lawId=16530825212161&showType=1",
  },
  {
    number: "4",
    name: "Системийн танилцуулга (видео)",
    date: "2022-05-31",
    link: "https://www.youtube.com/watch?v=oN7D4MSjDv0",
  },
];

const manualData = [
  {
    number: "1",
    name: "Систем ашиглах заавар",
    link: "https://drive.google.com/drive/u/2/folders/1_zX7qnYbNO5vmG39RsqtwCSA3m895Qr-",
  },
  {
    number: "2",
    name: "Бүртгүүлэх заавар (видео)",
    link: "https://www.youtube.com/watch?v=ZGRx2nB56Lg",
  },
];

/* ── Tab keys ── */
type TabKey = "rules" | "certificate" | "manual";

/* ── Component ── */

const Login = () => {
  const history = useHistory();
  const [showRegister, changeShowRegister] = useState(false);
  const [activeTab, setActiveTab] = useState<TabKey>("rules");
  const [login, changeLogin] = useState({ name: "", password: "" });

  /* Certificate check state */
  const [certId, setCertId] = useState("");
  const [certVisible, setCertVisible] = useState(false);

  const handleClick = useCallback(async () => {
    let result = await NetworkApi.requestPost("/api/auth/login", login);
    if (result.resultCode == 200) {
      message.success("Системд амжилттай нэвтэрлээ...");
      window.localStorage.setItem("announcement", JSON.stringify(true));
      if (result.result?.user?.role?.cd === USER_ROLE.WAREHOUSE_SPECIALIST) {
        window.location.href = "/wm/warehouse";
      } else {
        window.location.href = "/";
      }
    } else {
      message.error(result.message || "Системийн алдаа");
    }
  }, [login]);

  const onFinish = () => {};

  /* ── Tab content renderers ── */

  const renderRules = () => (
    <>
      <div className="login-tab-content-header">
        <div className="header-dot" />
        <h4>Дүрэм журам, тушаал шийдвэр</h4>
      </div>
      <div className="login-data-list">
        {rulesData.map((item) => (
          <div className="login-data-item" key={item.number}>
            <div className="item-number">{item.number}</div>
            <div className="item-content">
              <div className="item-title">{item.name}</div>
              <div className="item-meta">
                <span className="item-date">{item.date}</span>
                <span className="item-link">
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    <LinkOutlined /> Үзэх
                  </a>
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  const renderCertificate = () => (
    <>
      <div className="login-tab-content-header">
        <div className="header-dot" style={{ background: "#2E8B7A" }} />
        <h4>Гарал үүслийн гэрчилгээ лавлах</h4>
      </div>
      <div className="login-cert-check">
        <h3>
          <QrcodeOutlined /> ГҮГ шалгах
        </h3>
        <div className="cert-input-row">
          <Input
            value={certId}
            onChange={(e) => setCertId(e.target.value)}
            placeholder="Гэрчилгээний дугаар оруулах"
            onPressEnter={() => certId && setCertVisible(true)}
            style={{ flex: 1 }}
          />
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={() => certId && setCertVisible(true)}
          >
            Шалгах
          </Button>
        </div>
      </div>
      <Modal
        width={1240}
        centered
        visible={certVisible}
        onCancel={() => setCertVisible(false)}
        footer={[
          <Button key="close" onClick={() => setCertVisible(false)}>
            Хаах
          </Button>,
        ]}
      >
        <License
          isSmall={false}
          id={certVisible ? certId : ""}
          key="PrintLicense"
        />
      </Modal>
    </>
  );

  const renderManual = () => (
    <>
      <div className="login-tab-content-header">
        <div className="header-dot" style={{ background: "#B8860B" }} />
        <h4>Гарын авлага, заавар</h4>
      </div>
      <div className="login-data-list">
        {manualData.map((item) => (
          <div className="login-data-item" key={item.number}>
            <div className="item-number">{item.number}</div>
            <div className="item-content">
              <div className="item-title">{item.name}</div>
              <div className="item-meta">
                <span className="item-link">
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    <LinkOutlined /> Үзэх
                  </a>
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  const tabContent: Record<TabKey, () => JSX.Element> = {
    rules: renderRules,
    certificate: renderCertificate,
    manual: renderManual,
  };

  return (
    <Layout className="login-layout">
      {/* ══════ Header ══════ */}
      <header className="login-header">
        <div className="login-header-left">
          <img
            src="/logosingle.png"
            alt="ХХААХҮЯ"
            className="login-header-logo"
          />
          <div className="login-header-divider" />
          <div>
            <h1 className="login-header-title">
              Тариалан үйлдвэрлэлийн нэгдсэн систем
            </h1>
            <div className="login-header-subtitle">
              Хүнс, хөдөө аж ахуй, хөнгөн үйлдвэрийн яам
            </div>
          </div>
        </div>
      </header>
      <div className="login-gold-bar" />

      {/* ══════ Main ══════ */}
      <div className="login-main">
        {/* ── Left: Info Panel ── */}
        <div className="login-info-panel">
          {/* Custom tab buttons */}
          <div className="login-custom-tabs">
            <div
              className={`login-custom-tab ${activeTab === "rules" ? "active" : ""}`}
              onClick={() => setActiveTab("rules")}
            >
              <div className="tab-icon icon-rules">
                <FileDoneOutlined />
              </div>
              <span className="tab-text">Дүрэм журам</span>
            </div>
            <div
              className={`login-custom-tab ${activeTab === "certificate" ? "active" : ""}`}
              onClick={() => setActiveTab("certificate")}
            >
              <div className="tab-icon icon-cert">
                <QrcodeOutlined />
              </div>
              <span className="tab-text">ГҮГ лавлах</span>
            </div>
            <div
              className={`login-custom-tab ${activeTab === "manual" ? "active" : ""}`}
              onClick={() => setActiveTab("manual")}
            >
              <div className="tab-icon icon-manual">
                <FilePdfFilled />
              </div>
              <span className="tab-text">Гарын авлага</span>
            </div>
          </div>

          {/* Tab content */}
          <div className="login-tab-content">{tabContent[activeTab]()}</div>
        </div>

        {/* ── Right: Login Form ── */}
        <div className="login-form-panel">
          <div className="login-form-card">
            <div className="login-form-header">
              <div className="login-form-emblem">
                <SafetyOutlined />
              </div>
              <h2 className="login-form-title">Нэвтрэх</h2>
              <p className="login-form-desc">
                Системд нэвтрэхийн тулд мэдээллээ оруулна уу
              </p>
            </div>

            <Form
              name="login_form"
              initialValues={{ remember: true }}
              onFinish={onFinish}
            >
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Хэрэглэгчийн нэрээ оруулна уу!",
                  },
                ]}
              >
                <Input
                  size="large"
                  value={login.name}
                  onChange={(t) =>
                    changeLogin({ ...login, name: t.target.value })
                  }
                  placeholder="Нэвтрэх нэр"
                  prefix={<UserOutlined style={{ color: "#A0AEC0" }} />}
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{ required: true, message: "Нууц үгээ оруулна уу!" }]}
              >
                <Input.Password
                  size="large"
                  value={login.password}
                  onChange={(t) =>
                    changeLogin({ ...login, password: t.target.value })
                  }
                  placeholder="Нууц үг"
                  prefix={<LockOutlined style={{ color: "#A0AEC0" }} />}
                />
              </Form.Item>

              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox>Намайг сана</Checkbox>
              </Form.Item>

              <Form.Item style={{ marginTop: 20 }}>
                <Button
                  type="primary"
                  onClick={handleClick}
                  htmlType="submit"
                  block
                >
                  Нэвтрэх
                </Button>
              </Form.Item>

              <div className="login-form-links">
                <Button
                  type="link"
                  onClick={() => history.push("/forgot/password")}
                >
                  Нууц үг мартсан
                </Button>
                <Button type="link" onClick={() => changeShowRegister(true)}>
                  Бүртгүүлэх
                </Button>
              </div>
            </Form>
          </div>

          {/* Web links */}
          <div className="login-weblinks">
            <div className="login-weblinks-title">Холбоосууд</div>
            <a
              href="https://mofa.gov.mn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Хүнс, хөдөө аж ахуй, хөнгөн үйлдвэрийн яам
            </a>
            <a
              href="http://khaads.mn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Хөдөө аж ахуйн дэмжлэгийн сан
            </a>
          </div>
        </div>
      </div>

      {/* ══════ Contact Info ══════ */}
      <div className="login-contact-section">
        <div className="login-contact-inner">
          <div className="login-contact-header">
            <BankOutlined className="login-contact-header-icon" />
            <div>
              <h3 className="login-contact-title">Холбоо барих</h3>
              <p className="login-contact-org">
                Газар тариалангийн бодлогын хэрэгжилтийг зохицуулах газар
              </p>
            </div>
          </div>
          <div className="login-contact-grid">
            {/* Phone 1 */}
            <div className="login-contact-card">
              <div className="login-contact-phone">
                <PhoneOutlined />
                <a href="tel:51262713">5126-2713</a>
              </div>
              <ul className="login-contact-list">
                <li>Үр тариа, тос, тэжээлийн таримлын үйлдвэрлэл, хангамж</li>
                <li>Газар тариалангийн үйлдвэрлэл, органик бүтээгдэхүүн</li>
              </ul>
            </div>
            {/* Phone 2 */}
            <div className="login-contact-card">
              <div className="login-contact-phone">
                <PhoneOutlined />
                <a href="tel:51263408">5126-3408</a>
              </div>
              <ul className="login-contact-list">
                <li>Төмс, хүнсний ногооны үйлдвэрлэл</li>
                <li>Тариалангийн газрын ашиглалт, хөрсний үржил шим</li>
                <li>Жимс жимсгэнэ, ашигт таримлын үйлдвэрлэл</li>
                <li>Таримал ургамлын үр, сорт</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* ══════ Footer ══════ */}
      <footer className="login-footer">
        <div className="login-footer-left">
          <img
            src="/logosingle.png"
            alt="ХХААХҮЯ"
            className="login-footer-logo"
          />
          <p className="login-footer-text">
            Зохиогчийн эрх ©{new Date().getFullYear()} Хүнс, хөдөө аж ахуй,
            хөнгөн үйлдвэрийн яам
          </p>
        </div>
        <div className="login-footer-social">
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <TwitterOutlined />
          </a>
          <a
            href="https://www.facebook.com/mofagovmn"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FacebookFilled />
          </a>
        </div>
      </footer>

      <Register visible={showRegister} hide={() => changeShowRegister(false)} />
    </Layout>
  );
};

export default Login;
